import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import DomainDetails from './DomainDetails';
import Languages from './Languages';
import Button from '@material-ui/core/Button';
import SaveButtonWithoutIcon from '../../../components/SaveButtonWithoutIcon';
import Typography from '@material-ui/core/Typography';
import { useDataProvider } from 'react-admin';
import { getAccountId } from '../../../token';
import { handleAPIErrors } from '../../../utils';

const styles = theme => ({
  root: {
    backgroundColor: 'transparent',
  },
  button: {
    marginTop: theme.spacing(),
    marginBottom: theme.spacing(),
    marginLeft: theme.spacing(),
  },
  sectionHeader: {
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  savingSection: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: '91px',
    marginBottom: '40px',
  },
});

function CreationForm(props) {
  const [account, setAccount] = useState(null);
  const [templates, setTemplates] = useState({
    pop_up_templates: {},
    declaration_templates: {},
    choice_box_templates: {},
  });

  const dataProvider = useDataProvider();
  const { classes, ...rest } = props;

  useEffect(() => {
    if (!account) {
      setAccountId(getAccountId());
    }
  }, [account]);

  const setAccountId = (newAccount) => {
    setAccount(newAccount);
    getTemplatesForAccount(newAccount);
  };

  const getTemplatesForAccount = (queriedAccount) => {
    if (!queriedAccount) {
      return false;
    }

    if (account !== queriedAccount || Object.keys(templates).length) {
      setTemplates({});
    }

    const templatesTypes = [
      'pop_up_templates',
      'declaration_templates',
      'choice_box_templates',
    ];

    let templates = {};

    for (const templateType of templatesTypes) {
      dataProvider.getList(templateType, {
        pagination: {
          page: 1,
        },
        sort: {
          field: 'id',
          order: 'DESC',
        },
        filter: {
          accounts: queriedAccount,
          itemsPerPage: 1000,
        },
      }).then(templatesResponse => {
        templates[templateType] = templatesResponse.data;

        setTemplates(templates);
      }).catch(error => {
        handleAPIErrors(error, props.history);
        console.error(error);
      });
    }
  };

  return (
    <div>
      <DomainDetails {...props} onAccountChange={setAccountId} templates={templates}/>
      <Typography variant="h5" gutterBottom className={classes.sectionHeader}>Languages</Typography>
      <Languages {...props} />
      <div className={classes.savingSection}>
        <Button href="#/websites" className={classes.button}>Cancel</Button>
        <SaveButtonWithoutIcon
          handleSubmitWithRedirect={rest.handleSubmitWithRedirect}
          color="secondary"
          label="Create consent solution"
          data-testid="create-consent-solution-next-button"
          saving={rest.saving}
          className={`${classes.button} create-consent-solution-save-button`}
          submitOnEnter={rest.submitOnEnter}
          disabled={rest.invalid || rest.isSaving}
        />
      </div>
    </div>
  );
}

export default withStyles(styles)(CreationForm);
